export function getStrategyContextState({ strategy, inDojo = false, readOnly = false } = {}) {
  const payloadMarksDojoStrategy = strategy?._isDojoStrategy === true;
  return {
    inDojoContext: Boolean(payloadMarksDojoStrategy || inDojo || readOnly),
    readOnlyStrategy: Boolean(payloadMarksDojoStrategy || readOnly),
  };
}

export function getDojoStrategyAccess(dojo) {
  if (!dojo) return { inDojo: false, readOnly: false, canEdit: true, dojoName: null };
  const canEdit = dojo?.user_membership?.can_edit_strategy_plan === true;
  return {
    inDojo: true,
    readOnly: !canEdit,
    canEdit,
    dojoName: dojo.name || null,
  };
}
